import { RequestedFields, TriggerFlow, DestinationScope, } from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
export function hasValidationsInCart(ecommerceSettingsResponse) {
    var _a, _b;
    if (hasRequestedFieldError(ecommerceSettingsResponse.errors, RequestedFields.VALIDATIONS_SERVICE_PLUGIN) ||
        !((_b = (_a = ecommerceSettingsResponse.ecommerceSettings) === null || _a === void 0 ? void 0 : _a.validationsServicePlugin) === null || _b === void 0 ? void 0 : _b.activeProviders)) {
        return true;
    }
    return ecommerceSettingsResponse.ecommerceSettings.validationsServicePlugin.activeProviders.some(function (item) { var _a; return (_a = item.triggerFlows) === null || _a === void 0 ? void 0 : _a.some(function (flow) { return flow === TriggerFlow.CART; }); });
}
export function hasAdditionalFees(ecommerceSettingsResponse) {
    var _a, _b;
    if (hasRequestedFieldError(ecommerceSettingsResponse.errors, RequestedFields.ADDITIONAL_FEES_SERVICE_PLUGIN) ||
        !((_b = (_a = ecommerceSettingsResponse.ecommerceSettings) === null || _a === void 0 ? void 0 : _a.additionalFeesServicePlugin) === null || _b === void 0 ? void 0 : _b.activeProviders)) {
        return true;
    }
    return ecommerceSettingsResponse.ecommerceSettings.additionalFeesServicePlugin.activeProviders.length > 0;
}
export function canBusinessShip(ecommerceSettingsResponse) {
    var _a, _b, _c, _d, _e;
    var destinationScope = (_b = (_a = ecommerceSettingsResponse.ecommerceSettings) === null || _a === void 0 ? void 0 : _a.delivery) === null || _b === void 0 ? void 0 : _b.destinationScope;
    var destinations = (_e = (_d = (_c = ecommerceSettingsResponse.ecommerceSettings) === null || _c === void 0 ? void 0 : _c.delivery) === null || _d === void 0 ? void 0 : _d.destinations) !== null && _e !== void 0 ? _e : [];
    if (!hasRequestedFieldError(ecommerceSettingsResponse.errors, RequestedFields.DELIVERY) &&
        (destinationScope === DestinationScope.WORLDWIDE ||
            (destinationScope === DestinationScope.SPECIFIC_DESTINATIONS && destinations.length > 0))) {
        return true;
    }
    return false;
}
export function hasRequestedFieldError(errors, expectedRequestedField) {
    return errors === null || errors === void 0 ? void 0 : errors.some(function (_a) {
        var requestedField = _a.requestedField;
        return requestedField === expectedRequestedField;
    });
}
//# sourceMappingURL=eCommerceSettingsService.utils.js.map